import Modal from "../../common/atoms/modal";
import React, {useEffect, useState} from "react";
import Utility from "../../utility";
import referralService from "../../services/referralList";
import {MainContainer} from "../../modules/referrals/styles";
import TableComponent from "../../common/components/TableComponent";

const ReferredUserListModal = ({isVisible, setVisible, id}) => {
    const [referredUserList, setReferralList] = useState([])

    const fetchReferredUsers = async () => {
        if (!id) return;
        let [err, referrals] = await Utility.parseResponse(referralService.getReferredUserList(id),);
        if (!referrals || err)
            return Utility.apiFailureToast("Unable to fetch referralList");
        setReferralList(referrals)
    }
    useEffect(() => {
        fetchReferredUsers().then(() => "DONE")
    }, [id])

    const onModalClose = () => {
        setVisible(false)
        setReferralList([])
    }

    return (
        <Modal isVisible={isVisible} onClose={onModalClose} title={'Referred users'}>
            <MainContainer>
                <TableComponent.Table cellpadding="0" cellspacing="0">
                    <TableComponent.TableHead>
                        <TableComponent.HeadColumn>User name</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Phone</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Plan Name</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Plan amount</TableComponent.HeadColumn>
                        <TableComponent.HeadColumn>Activated On</TableComponent.HeadColumn>
                    </TableComponent.TableHead>
                    <TableComponent.TableBody>
                        {referredUserList?.map((item) => (
                            <TableComponent.BodyRow key={item._id}>
                                <TableComponent.BodyColumn>{item.user?.name || "-"}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.user?.phone}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.plan?.name}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{item.plan?.price}</TableComponent.BodyColumn>
                                <TableComponent.BodyColumn>{new Date(item.startAt).toDateString()}</TableComponent.BodyColumn>
                            </TableComponent.BodyRow>
                        ))}
                    </TableComponent.TableBody>
                </TableComponent.Table>
                {referredUserList?.length === 0 ? "Loading..." : ""}

            </MainContainer>

        </Modal>
    )
}
export default ReferredUserListModal
